export default "__VITE_ASSET__73ea0805__"